"use client"
import "./ResultsTable.css"

const ResultsTable = ({ results }) => {
  if (!results || !results.data || results.data.length === 0) {
    return <div className="no-results">No calculation results available</div>
  }

  return (
    <div className="results-table-container">
      <table className="results-table">
        <thead>
          <tr>
            <th>Date</th>
            {results.models.map((model) => (
              <th key={model.id}>{model.name}</th>
            ))}
            <th>Weather Data</th>
          </tr>
        </thead>
        <tbody>
          {results.data.map((day, index) => (
            <tr key={index}>
              <td>{new Date(day.date).toLocaleDateString()}</td>
              {results.models.map((model) => (
                <td key={`${day.date}-${model.id}`}>
                  {day.etref[model.id] ? day.etref[model.id].toFixed(2) : "N/A"} mm/day
                </td>
              ))}
              <td>
                <button
                  className="weather-details-button"
                  onClick={() => alert("Weather details modal would open here")}
                >
                  <i className="fas fa-info-circle"></i>
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default ResultsTable
